import{useRef as r,useEffect as t}from"react";var n=function(n,c){var o=r(!1);t((function(){o.current?n():o.current=!0}),c)};export{n as u};
